import { Card, DataDisplay, DateTimePicker, Grid, Stack, Typography, ValidationErrors, formatPhoneNumber, pn } from "@compass/core";
import { Input } from "components";
import { SaveTextingQueueRequestDto, TextingQueueDetailDto } from "generated/openApi";
import { useDateTime } from "hooks";
import { TextingStatusChip } from "../TextingStatusChip";

export const TextingQueueInfo = (props: {
  textingQueue: TextingQueueDetailDto;
  setTextingQueue: (textingQueue: TextingQueueDetailDto) => void;
  isEditing: boolean;
  validationErrors: ValidationErrors;
}) => {
  const formatDateTime = useDateTime();
  const queue = props.textingQueue;
  const nameProperty = pn<SaveTextingQueueRequestDto>("name");
  const scheduledDateProperty = pn<SaveTextingQueueRequestDto>("scheduledDate");
  const messageProperty = pn<SaveTextingQueueRequestDto>("message");

  return (
    <Stack spacing="lg">
      <Card header="Queue Information">
        <Grid container spacing="lg">
          <Grid item lg={3} md={4} sm={6} xs={12}>
            {props.isEditing ? (
              <Input
                label="Name"
                errors={props.validationErrors[nameProperty]}
                value={queue.name}
                onChange={(event) => props.setTextingQueue({ ...queue, name: event.target.value })}
              />
            ) : (
              <DataDisplay label="Name">{queue.name || "-"}</DataDisplay>
            )}
          </Grid>
          <Grid item lg={3} md={4} sm={6} xs={12}>
            <DataDisplay label="Status">
              {queue.status ? <TextingStatusChip status={queue.status} /> : "-"}
            </DataDisplay>
          </Grid>
          <Grid item lg={3} md={4} sm={6} xs={12}>
            <DataDisplay label="Person Type">{queue.personType || "-"}</DataDisplay>
          </Grid>
          <Grid item lg={3} md={4} sm={6} xs={12}>
            <DataDisplay label="Sent/Total">{queue.sent}/{queue.total}</DataDisplay>
          </Grid>
          <Grid item lg={3} md={4} sm={6} xs={12}>
            <DataDisplay label="Source Number">{formatPhoneNumber(queue.sourcePhoneNumber) || "-"}</DataDisplay>
          </Grid>
          <Grid item lg={3} md={4} sm={6} xs={12}>
            {props.isEditing ? (
              <DateTimePicker
                label="Scheduled Time"
                errors={props.validationErrors[scheduledDateProperty]}
                value={queue.scheduledDate ?? null}
                onChange={(value) => props.setTextingQueue({ ...queue, scheduledDate: value ?? undefined })}
              />
            ) : (
              <DataDisplay label="Scheduled Time">{formatDateTime(queue.scheduledDate) || "-"}</DataDisplay>
            )}
          </Grid>
          <Grid item lg={3} md={4} sm={6} xs={12}>
            <DataDisplay label="Completed Date">{formatDateTime(queue.completedDate) || "-"}</DataDisplay>
          </Grid>
          <Grid item lg={3} md={4} sm={6} xs={12}>
            <DataDisplay label="Cancelled Date">{formatDateTime(queue.cancelledDate) || "-"}</DataDisplay>
          </Grid>
        </Grid>
      </Card>

      <Card header="Message">
        {props.isEditing ? (
          <Input
            label="Message"
            errors={props.validationErrors[messageProperty]}
            multiline
            value={queue.message}
            onChange={(event) => props.setTextingQueue({ ...queue, message: event.target.value })}
          />
        ) : (
          <Typography sx={{ whiteSpace: "pre-wrap", overflowWrap: "anywhere" }}>
            {queue.message || "-"}
          </Typography>
        )}
      </Card>
    </Stack>
  );
};
